import type { ReactNode } from 'react';
import { cx } from './cx.js';

export type Tone = 'info' | 'success' | 'warning' | 'danger';

const ICON: Record<Tone, string> = { info: 'i', success: '✓', warning: '!', danger: '!' };

export interface AlertProps {
  tone?: Tone;
  title?: ReactNode;
  children?: ReactNode;
  className?: string;
  /** Rendered at the end (e.g. a retry button). */
  action?: ReactNode;
}

/** Inline message. Danger and warning are announced at once (role=alert). */
export function Alert({ tone = 'info', title, children, className, action }: AlertProps) {
  return (
    <div
      role={tone === 'danger' || tone === 'warning' ? 'alert' : 'status'}
      className={cx('qk-alert', `qk-alert--${tone}`, className)}
    >
      <span className="qk-alert__icon" aria-hidden="true">
        {ICON[tone]}
      </span>
      <div className="qk-alert__body">
        {title ? <p className="qk-alert__title">{title}</p> : null}
        {children ? <div className="qk-alert__text">{children}</div> : null}
      </div>
      {action ? <div className="qk-alert__action">{action}</div> : null}
    </div>
  );
}
